//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BScroll from "better-scroll";
export default {
  data() {
    return {
      logo: "http://placekitten.com/g/230/300",
      showLayer: false,
      isPortrait: window.orientation === 0 ? true : false,
      isSafari: this.isMobileSafari()
    };
  },
  methods: {
    initScroll() {
      let wrapper = document.querySelector(".outer");
      if (!this.bscroll) {
        this.bscroll = new BScroll(wrapper, {
          pullUpLoad: {
            threshold: 50
          },
          click: true,
          bounce: {
            top: false,
            bottom: false,
            left: false,
            right: false
          }
        });
      } else {
        this.bscroll.refresh();
      }
    },
    handleOrientationChange() {
      this.isPortrait = window.orientation === 0 ? true : false;
    },
    handleAddToScreen() {
      this.showLayer = true;
      // document.title = "iPad和iPhone的Safari“添加至主屏幕”功能如何自定义图标";
      // window.history.pushState({}, 0, '/');
      // var head = document.getElementsByTagName('head')[0],
      //   cssURL = '//gss0.bdstatic.com/5bd1bjqh_Q23odCf/static/wiseindex/img/screen_icon_new.png',
      //   linkTag = document.createElement('link');
      // linkTag.href = cssURL;
      // linkTag.setAttribute('rel', 'apple-touch-icon');
      // head.appendChild(linkTag);
    },
    handleToHome() {
      this.$router.push("/");
    },
    isMobileSafari() {
      let agent = navigator.userAgent;
      let isIDevice = /iphone|ipod|ipad/i.test(agent);
      let isMobileSafari =
        isIDevice &&
        /Safari/.test(navigator.userAgent) &&
        !/Chrome/.test(navigator.userAgent);
      return isMobileSafari;
    }
  },
  destroyed() {
    window.removeEventListener(
      "orientationchange",
      this.handleOrientationChange,
      false
    );
  },
  mounted() {
    window.addEventListener(
      "orientationchange",
      this.handleOrientationChange,
      false
    );
    this.initScroll();
  }
};
